import { customization } from '@yola/ws-sdk';
import updateColorPaletteCode from '../helpers/update-color-palette-code';

const backfillCustomPaletteParentIds = (store, state) => {
  const customPalettes = customization.selectors.getCustomColorPalettes(state);
  customPalettes.forEach((palette) => {
    if (palette.parentId) return;
    store.dispatch(
      customization.actions.updateCustomColorPalette({
        ...palette,
        parentId: 'palette-1',
      })
    );
  });
};

const colorPaletteMigration = (store) => {
  const state = store.getState();
  const colorPaletteVersion = customization.selectors.getColorPaletteVersion(state);
  const currentColorPaletteVersion = customization.selectors.getCurrentColorPaletteVersion(state);
  let palette = customization.accessors.getCurrentColorPalette();
  const isColorPaletteVersionChanged = currentColorPaletteVersion !== colorPaletteVersion;

  backfillCustomPaletteParentIds(store, state);

  if (!isColorPaletteVersionChanged && palette) return false;

  if (!palette) {
    const defaultColorPaletteId = customization.selectors.getDefaultColorPaletteId(state);
    palette = customization.selectors.getColorPalette(state, defaultColorPaletteId);
  }

  updateColorPaletteCode(palette);

  if (isColorPaletteVersionChanged) {
    store.dispatch(customization.actions.setCurrentColorPaletteVersion(colorPaletteVersion));
  }
  return true;
};

export default colorPaletteMigration;
